module.exports = __webpack_public_path__ + "img/seo-rank-tracker.aece7abe.png";